import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #HEADER
\*------------------------------------ */
/**
  * 1) Global header where the navigation, logo, and other content lives across the entire site
  */
.cat-c-header {
  background: var(--cat-theme-color-background-xstrong);
  color: var(--cat-theme-color-content-brand);
  position: relative;
  width: 100%;
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-header {
    z-index: var(--cat-z-index-300);
  }
  .cat-c-header.cat-skip-link-active {
    z-index: auto;
  }
}

/**
 * Header top section
 * 1) Optional slot used for global navigation usually
 */
.cat-c-header__top {
  position: relative;
  inset-block-start: 0;
  width: 100%;
}

/**
 * Inner container of the header top section
 * 1) Used to cap the width of the content within the header
 */
.cat-c-header__top-inner {
  width: 100%;
}

/**
 * Header middle section
 * 1) Section of the site used for the logo and primary navigation
 */
.cat-c-header__middle {
  position: relative;
  width: 100%;
  box-shadow: var(--cat-theme-box-shadow-sm);
  padding-block: var(--cat-header-middle-padding-block-start) var(--cat-header-middle-padding-block-end);
}

/**
 * Header middle container
 * 1) This acts like a layout container but is flexible for different applications
 */
.cat-c-header__middle-container {
  width: 100%;
  max-width: var(--cat-header-middle-max-width);
  margin: var(--cat-header-middle-margin);
  padding-inline: var(--cat-header-middle-padding-inline-start) var(--cat-header-middle-padding-inline-end);
}

/**
 * Inner container of the header middle section
 * 1) Used to cap the width of the content within the header
 */
.cat-c-header__middle-inner {
  display: flex;
  align-items: center;
  width: 100%;
}

.cat-c-header__skip-link {
  position: fixed;
  inset-block-start: var(--cat-header-skip-link-inset-block-start, -100%);
  inset-inline-start: var(--cat-header-skip-link-inset-inline-start, calc(var(--size-base-unit) * 2));
  z-index: var(--cat-header-skip-link-zindex, 500);
  transition: inset-block-start 0.05s ease-in;
}

.cat-c-header__skip-link:focus-within {
  inset-block-start: var(--cat-header-skip-link-inset-block-start, calc(var(--size-base-unit) * 2));
}
`;
       